import type { TitleHeight } from '@tempo-io/roadmap-dto';

export const NO_VALUE_ID = 'null';

export const TITLE_HEIGHT_TO_LINES: Record<TitleHeight, number> = {
  'show-less': 1,
  default: 3,
  'show-more': 5,
};
